// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/app"], function() { return __webpack_require__("./node_modules/swiper/swiper-bundle.min.js"); })
__webpack_require__.O(undefined, ["css/app"], function() { return __webpack_require__("./src/js/app.js"); })
__webpack_require__.O(undefined, ["css/app"], function() { return __webpack_require__("./src/js/vue.js"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/app"], function() { return __webpack_require__("./src/css/app.css"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
